import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_GET_RECEPTION, RECEPTION_GET_RECEPTION_SECTIONS, RECEPTION_GET_SECTION, RECEPTION_SET_LOADER_STATE, RECEPTION_LOADERS } from '../../../store/reception/reception-types.store';
import { IReceptionDetailViewModel, IReceptionSectionListingViewModel } from '../../../models/reception';
import { ActivityStatus } from '../../../common/enums';
const ReceptionStore = namespace(RECEPTION_MODULE_NAMESPACE);

@Component({
  components: {
    'child-detail-header': async () => import('../components/mh-reception-detail-header/MHReceptionDetailHeader.vue'),
    'child-detail-general-info': async () => import('../components/mh-reception-detail-general-info/MHReceptionDetailGeneralInfo.vue'),
    'child-detail-section-detail': async () => import('../components/mh-reception-section-detail/MHReceptionSectionDetail.vue'),
    'child-detail-loader': async () => import('../loaders/reception-details-loader/ReceptionDetailsLoader.vue')
  }
})
class MHReceptionChildDetailContainer extends Vue {

  readonly LOADER_SECTIONS : { name: string }[] = [
    { name: 'EXTERIEUR' },
    { name: 'SALON / SEJOUR' }
  ] 
  /**
   *
   */
  constructor() {
    super();
  }

  @ReceptionStore.Getter receptionSource: {
    activityStatus: ActivityStatus,
    detail: IReceptionDetailViewModel
  }
  @ReceptionStore.Getter receptionSections: {
    activityStatus: ActivityStatus,
    data: IReceptionSectionListingViewModel[]
  }

  @ReceptionStore.Getter loaders: Map<string,boolean>

  @ReceptionStore.Action(RECEPTION_GET_RECEPTION)
  storeGetReceptionById?: (id: string) => Promise<IReceptionDetailViewModel>

  @ReceptionStore.Action(RECEPTION_GET_RECEPTION_SECTIONS)
  storeGetReceptionSectionsByReceptionId?: (id: string) => Promise<any>
  @ReceptionStore.Action(RECEPTION_GET_SECTION)
  storeGetSectionById?: (payload: { receptionId: string, sectionId: number, itemId: number }) => Promise<any>

  @ReceptionStore.Mutation(RECEPTION_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void


  get receptionId(): string {
    return this.$route.params.id
  }
  get isLoading(): boolean {
    return this.receptionSource.activityStatus === ActivityStatus.Loading;
  }

  get reception() {
    return this.receptionSource.detail;
  }
  get block() {
    return this.reception.block;
  }
  get participants() { return this.reception.participants }
  get sections(): IReceptionSectionListingViewModel[] {
    const sections: any[]= this.receptionSource.detail['sections']
    return this.coLoader  ? this.LOADER_SECTIONS : sections
  }
  get coLoader(): boolean {
    return this.loaders.get(RECEPTION_LOADERS.DETAILS)
  }

  @Watch("$route.params.id")
  watchReceptionIdChange(value: string) {
    this.storeSetLoaderState({ key: RECEPTION_LOADERS.DETAILS, value: true })
    this.storeGetReceptionById!(value)
       .finally(()=> this.storeSetLoaderState({ key: RECEPTION_LOADERS.DETAILS, value: false }) )
  }

  mounted() {
    this.storeSetLoaderState({ key: RECEPTION_LOADERS.DETAILS, value: true })
    this.storeGetReceptionById!(this.receptionId)
      .finally(()=> this.storeSetLoaderState({ key: RECEPTION_LOADERS.DETAILS, value: false }) )
  }

  handleCollapse(section, reception) {
    const extraRow = this.$refs[`extra-row-${section.id}-${reception.id}`][0];
    if (extraRow) {
      if (extraRow.className.indexOf('reception__title--hidden') > -1) {
        extraRow.className = extraRow.className.replace('reception__title--hidden','');
      } else {
        extraRow.className += 'reception__title--hidden';
      }
    }
  }


}

export default MHReceptionChildDetailContainer;



// WEBPACK FOOTER //
// ./src/containers/mh-reception/mh-reception-child-detail/index.ts